var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterResources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-waterresources"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "waterresources",
    clipPath: "url(#clip-waterresources)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M81-150.146c0,.968.056,1.135.335,1.135a7.058,7.058,0,0,1,1.619.763c2.234,1.322,2.774,1.322,4.933-.019,1.4-.856,2.178-.949,3.165-.372,2.978,1.731,3.332,1.75,5.584.447,1.861-1.061,2.29-1.061,4.151.019a10.106,10.106,0,0,0,1.955.949c.6.13,1.582-.242,2.848-1.042a4.792,4.792,0,0,1,1.433-.67c.6-.112.6-.13.6-1.21,0-.838-.056-1.1-.279-1.1a13.923,13.923,0,0,0-3.071,1.4c-1.042.6-1.489.54-3.239-.5a3.687,3.687,0,0,0-2.345-.782,3.847,3.847,0,0,0-2.42.819c-1.806,1.08-2.29,1.08-4.058.019-1.638-.987-2.755-1.173-3.76-.614-.354.2-1.136.633-1.731.949-1.266.726-1.582.689-3.407-.372a9.392,9.392,0,0,0-1.787-.856L81-151.3Z",
    transform: "translate(-79 170.46)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M418.837,69.49l4.45-6.448,4.562,7.282-.886,3.224-2.891,2.221-2.922-.775-2.471-2.439Z",
    transform: "translate(-408 -60)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M81-150.146c0,.968.056,1.135.335,1.135a7.058,7.058,0,0,1,1.619.763c2.234,1.322,2.774,1.322,4.933-.019,1.4-.856,2.178-.949,3.165-.372,2.978,1.731,3.332,1.75,5.584.447,1.861-1.061,2.29-1.061,4.151.019a10.106,10.106,0,0,0,1.955.949c.6.13,1.582-.242,2.848-1.042a4.792,4.792,0,0,1,1.433-.67c.6-.112.6-.13.6-1.21,0-.838-.056-1.1-.279-1.1a13.923,13.923,0,0,0-3.071,1.4c-1.042.6-1.489.54-3.239-.5a3.687,3.687,0,0,0-2.345-.782,3.847,3.847,0,0,0-2.42.819c-1.806,1.08-2.29,1.08-4.058.019-1.638-.987-2.755-1.173-3.76-.614-.354.2-1.136.633-1.731.949-1.266.726-1.582.689-3.407-.372a9.392,9.392,0,0,0-1.787-.856L81-151.3Z",
    transform: "translate(-79 168.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M81.088-129.864c.056,1.061.093,1.173.521,1.3a10.193,10.193,0,0,1,1.768.894c1.787,1.042,2.42,1.042,4.374-.093,1.917-1.117,2.345-1.117,4.244,0,1.992,1.154,2.606,1.154,4.6-.019,1.917-1.136,2.327-1.136,4.281,0,1.768,1.042,2.55,1.117,3.816.391.465-.261,1.322-.689,1.917-.968l1.061-.5v-1.061A4.178,4.178,0,0,0,107.6-131a10.469,10.469,0,0,0-2.625,1.191c-1.526.912-2.141.894-3.965-.168a4.2,4.2,0,0,0-2.271-.838,4.2,4.2,0,0,0-2.271.838c-1.861,1.08-2.42,1.1-4.151.074a5.4,5.4,0,0,0-2.271-.875c-.894-.074-1.08-.019-2.439.782-1.806,1.061-2.532,1.117-3.816.3a11.237,11.237,0,0,0-2.327-1.21C81.032-131.037,81.032-131,81.088-129.864Z",
    transform: "translate(-79.05 151.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M81-108.9c0,.8.074,1.136.242,1.136a10.14,10.14,0,0,1,1.713.856c2.159,1.247,2.7,1.266,4.561.186,2.178-1.266,2.271-1.266,4.393-.112,2.2,1.191,2.643,1.191,4.821-.074a7.063,7.063,0,0,1,1.936-.856,8.629,8.629,0,0,1,2.159.931c2.178,1.173,2.55,1.191,4.393.112a11.985,11.985,0,0,1,1.917-.968c.447-.112.484-.186.484-1.21,0-1.378-.149-1.4-2.141-.242-2.159,1.247-2.55,1.247-4.43.149-2.066-1.21-2.662-1.229-4.71-.019a6.877,6.877,0,0,1-2.01.875,9.3,9.3,0,0,1-2.29-.931A9.008,9.008,0,0,0,89.8-110a8.4,8.4,0,0,0-2.2.931,8.912,8.912,0,0,1-2.234.931,6.381,6.381,0,0,1-1.955-.819,11.946,11.946,0,0,0-1.936-.968C81-110.037,81-110.037,81-108.9Z",
    transform: "translate(-79 134.848)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "drop",
    transform: "translate(9.949 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M15.552,14.329a5.252,5.252,0,0,1-5.246-5.246c0-2.7,4.316-8.248,4.808-8.871a.558.558,0,0,1,.876,0C16.482.836,20.8,6.378,20.8,9.083A5.252,5.252,0,0,1,15.552,14.329Zm0-12.855c-1.461,1.938-4.129,5.843-4.129,7.609a4.129,4.129,0,0,0,8.259,0C19.681,7.317,17.013,3.411,15.552,1.474Z",
    transform: "translate(-10.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M36.047,49.369a.558.558,0,1,1,0-1.117,1.9,1.9,0,0,0,1.9-1.9.558.558,0,0,1,1.117,0A3.016,3.016,0,0,1,36.047,49.369Z",
    transform: "translate(-30.801 -37.273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterResources);
export default __webpack_public_path__ + "static/media/waterResources.7f430f88.svg";
export { ForwardRef as ReactComponent };